<template>
    <main class="data-page score-page external-score-page">
        <section class="page-hero compact-hero">
            <div><small>LIVE MATCH CENTER</small><h1>即时比分</h1><p>全球足球赛事比分、赛程与比赛指数实时更新</p></div>
        </section>
        <section class="data-panel score-embed-panel">
            <div ref="scoreWrap" class="bfwrap"><iframe src="https://live.nowscore.com/free.htm" :style="frameStyle" title="第三方足球即时比分" scrolling="auto" frameborder="0"></iframe></div>
        </section>
    </main>
</template>

<script>
export default {
    name: 'Bifen',
    data(){ return { frameStyle: {} } },
    mounted(){
        this.$nextTick(this.resizeScoreFrame)
        window.addEventListener('resize', this.resizeScoreFrame)
    },
    activated(){ this.$nextTick(this.resizeScoreFrame) },
    beforeDestroy(){ window.removeEventListener('resize', this.resizeScoreFrame) },
    methods:{
        resizeScoreFrame(){
            const wrap=this.$refs.scoreWrap
            if(!wrap)return
            if(window.innerWidth>768){
                this.frameStyle={width:'100%',height:'100%',transform:'none'}
                return
            }
            const sourceWidth=1080
            const scale=Math.min(1,wrap.clientWidth/sourceWidth)
            const visibleHeight=Math.max(600,wrap.clientHeight||600)
            this.frameStyle={
                width:sourceWidth+'px',
                height:Math.ceil(visibleHeight/scale)+'px',
                transform:'scale('+scale+')',
                transformOrigin:'0 0'
            }
        }
    }
}
</script>

<style scoped></style>
